import React from 'react';
import { Link } from 'react-router-dom';
import TopbarNavDashboards from './TopbarNavDashboards';
// import TopbarNavUIElements from './TopbarNavUIElements';

const TopbarNav = () => (
  <nav className="topbar__nav">
    <TopbarNavDashboards />
    {/* <TopbarNavUIElements /> */}
    <Link className="topbar__nav-link" to="/documentation/introduction">Documentation</Link>
  </nav>
);

export default TopbarNav;
